export default "__VITE_ASSET__B16N_1yg__"